import { render, staticRenderFns } from "./AddMeetingParticipants.vue?vue&type=template&id=638f3f96"
import script from "./AddMeetingParticipants.vue?vue&type=script&lang=js"
export * from "./AddMeetingParticipants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports